<template>
  <div class="monitorinfo-container">
    <!--监控任务详情-->
    <van-nav-bar
      :title="details.name"
      left-arrow
      @click-left="onClickLeft"
      safe-area-inset-top fixed placeholder z-index="100"
    >
    </van-nav-bar>

    <van-cell-group>
      <van-cell title="任务编号">
        <template #extra>
          <el-tag size="small">{{ details.id }}</el-tag>
        </template>
      </van-cell>
      <van-cell title="检测方式">
        <template #extra>
          <el-tag size="small">{{ details.project }}</el-tag>
        </template>
      </van-cell>
      <van-cell title="目标状态">
        <template #extra>
          <el-tag size="small" type="success" :disable-transitions="true" v-if="details.urlstate == 1">正常
          </el-tag>
          <div v-else-if="details.urlstate == 0">
            <el-tag size="small" type="danger" :disable-transitions="true">异常</el-tag>
          </div>
          <el-tag size="small" v-else type="info" :disable-transitions="true">未知</el-tag>
        </template>
      </van-cell>
      <van-cell title="更新时间">
        <template #extra>
          <el-tag size="small">{{ details.update_time }}</el-tag>
        </template>
      </van-cell>
      <van-cell title="自动停用">
        <template #extra>
          <el-tag size="small" :type="details.switch ? 'success' : 'danger'">
            {{ details.switch ? '已开启' : '已关闭' }}
          </el-tag>
        </template>
      </van-cell>
      <van-cell title="监控节点">
        <template #extra>
          <el-tag size="small">{{ details.node }}</el-tag>
        </template>
      </van-cell>
      <van-cell title="通知方式">
        <template #extra>
          <el-tag type="info" size="small" v-if="!details.tongzhiswitch">未开启</el-tag>
          <el-tag v-else size="small">
            <span v-if="details.tongzhitype==1">邮件</span>
            <span v-else-if="details.tongzhitype==2">短信</span>
            <span v-else-if="details.tongzhitype==3">电话</span>
            <span v-else-if="details.tongzhitype==4">微信</span>
            <span v-else-if="details.tongzhitype==5">钉钉</span>
            <span v-else-if="details.tongzhitype==6">电报</span>
            <span v-else-if="details.tongzhitype==7">企业微信</span>
            <span v-else-if="details.tongzhitype==8">飞书</span>
          </el-tag>
        </template>
      </van-cell>
      <van-cell title="是否开启回调">
        <template #extra>
          <el-tag size="small" :type="details.callbackurlswitch ==1 ? 'success' : 'danger'">
            {{ details.callbackurlswitch == 1 ? '是' : '否' }}
          </el-tag>
        </template>
      </van-cell>
      <van-cell title="回调地址">
        <template #extra>
          <el-link v-if="details.callbackurl" :underline="false" type="primary" :href="details.callbackurl">
            {{ details.callbackurl }}
          </el-link>
          <el-tag v-else size="small" type="info">未开启</el-tag>
        </template>
      </van-cell>
      <van-cell title="执行时间段">
        <template #extra>
          <el-tag v-if="details.timeswitch == 1" size="small" type="primary">
            {{ JSON.parse(details.section_time)[0] | dateFormat }} 至
            {{ JSON.parse(details.section_time)[1] | dateFormat }}
          </el-tag>
          <el-tag v-else size="small" type="info">未开启</el-tag>
        </template>
      </van-cell>
      <van-cell title="任务名称">
        <template #extra>
          <el-tag size="small">{{ details.name }}</el-tag>
        </template>
      </van-cell>
      <van-cell title="监控目标">
        <template #extra>
          <el-link :underline="false" type="primary" target="_blank">{{ details.url }}</el-link>
        </template>
      </van-cell>
      <van-cell title="具体原因">
        <template #extra>
          <el-tag v-if="details.urlstate == 0" size="small" type="danger">
            {{ details.urlstatemsg }}
          </el-tag>
          <el-tag v-else size="small">无</el-tag>
        </template>
      </van-cell>
      <van-cell title="任务状态">
        <template #extra>
          <el-tag size="small" :type="details.stateswitch ? 'success' : 'danger'">
            {{ details.stateswitch ? '已开启' : '已停用' }}
          </el-tag>
        </template>
      </van-cell>
      <van-cell title="告警方式">
        <template #extra>
          <el-tag type="primary" size="small">{{ details.tongzhistate == 1 ? '异常告警' : '正常告警' }}</el-tag>
        </template>
      </van-cell>
      <van-cell title="是否开启通知">
        <template #extra>
          <el-tag size="small" :type="details.tongzhiswitch ? 'success' : 'danger'">
            {{ details.tongzhiswitch ? '是' : '否' }}
          </el-tag>
        </template>
      </van-cell>
      <van-cell title="通知账户">
        <template #extra>
          <el-tag size="small" v-if="details.mail">
            <!--邮件电话短信通知账户-->
            <span
              v-if="details.tongzhitype!=4&&details.tongzhitype!=5&&details.tongzhitype!=6&&details.tongzhitype!=7&&details.tongzhitype!=8 ">{{
                details.mail
              }}</span>
            <!--微信通知账户-->
            <span v-else-if="details.tongzhitype==4">
              <span v-for="item in $store.state.notice_wechat">
                <span v-if="item.open_id==details.mail">{{ item.nickname }}</span>
              </span>
            </span>
            <!--短信通知账户-->
            <span v-else-if="details.tongzhitype==5">
              <span v-for="item in $store.state.notice_dingtalk">
                <span v-if="item.id==details.mail">{{ item.name }}</span>
              </span>
            </span>
            <span v-else-if="details.tongzhitype==6">
              <span v-for="item in $store.state.notice_telegram">
                <span v-if="item.chat_id ==details.mail">
                  {{ item.type == 'group' ? '群聊' : '个人' }}：{{
                    item.type == 'group' ? item.name : item.username
                  }}
                </span>
              </span>
            </span>
            <span v-else-if="details.tongzhitype==7">
              <span v-for="item in $store.state.notice_enterprisewechat">
                <span v-if="item.id == details.mail">{{ item.name }}</span>
              </span>
            </span>
            <span v-else-if="details.tongzhitype==8">
              <span v-for="item in $store.state.notice_feishu">
                <span v-if="item.id == details.mail">{{ item.name }}</span>
              </span>
            </span>
          </el-tag>
          <el-tag v-else size="small" type="info">未开启</el-tag>
        </template>
      </van-cell>
      <van-cell title="是否开启报警复查">
        <template #extra>
          <el-tag size="small" :type="details.review_switch == 1 ? 'success' : 'danger'">
            {{ details.review_switch == 1 ? '是' : '否' }}
          </el-tag>
        </template>
      </van-cell>
      <van-cell title="报警复查次数" v-if="details.review_switch == 1">
        <template #extra>
          <el-tag size="small" type="success">
            复查{{ details.review_count }}次
          </el-tag>
        </template>
      </van-cell>
      <van-cell title="回调方式">
        <template #extra>
          <div v-if="details.callbackurlswitch ==1">
            <el-tag v-if="details.callbackurl_type == 1" size="small" type="primary">POST</el-tag>
            <el-tag v-else size="small" type="primary">GET</el-tag>
          </div>
          <el-tag v-else size="small" type="info">未开启</el-tag>
        </template>
      </van-cell>
      <van-cell title="是否开启时间段执行">
        <template #extra>
          <el-tag v-if="details.timeswitch == 1" size="small" type="success">已开启</el-tag>
          <el-tag v-else size="small" type="info">未开启</el-tag>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: 'MonitorInfo',
  mounted(){
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.onClickLeft, false);
    }
  },
  destroyed(){
    window.removeEventListener('popstate', this.onClickLeft, false);
  },
  props: ['details'],
  methods: {
    // 返回按钮
    onClickLeft() {
      this.$parent.showMonitorinfo = 1
    }
  }
}

</script>

<style lang="less" scoped>
.monitorinfo-container {
  min-height: 100vh;
  background-color: #ffffff;
}
</style>
